<template>
    <div class="footer-container">
        <div class="top-half">
            <div class="top-logo">
                <a href="/"><img :src="logoImage" alt="LLTC LOGO" style="width: 60px; height: 60px;" /></a> 
                <p>Lagos Lawn Tennis Club blends tradition with a contemporary spirit-curating spaces where players of
                    all levels improve, connect and compete</p>
                <button>More about us</button>

                <div class="play-app-store mt-3">
                    <img src="../assets/images/google.png" alt="">&nbsp;&nbsp;
                    <img src="../assets/images/apple.png" alt="">
                </div>
                <div class="down-half-buttons">
                    <button>
                        <a :href="dataList.facebook"> <img src="../assets/logo/footer/facebook.png" alt=""></a>
                    </button>
                    <button>
                        <a :href="dataList.instagram"> <img src="../assets/logo/footer/instagram.png" alt=""></a> 
                    </button>
                </div>
            </div>
        
            <div class="second-half">
                <div class="contact-location">
                    <div class="contact">
                        <h2>Contact Us</h2>
                        <ul>
                            <li>{{ dataList.phone }}</li>
                            <li>{{ dataList.email }}</li>
                        </ul>
                    </div>
                    <div class="location">
                        <h2>Location</h2>
                        <p>{{ dataList.address }}</p>
                    </div>
                </div>
                <div class="languages">
                    <p>Languages</p>
                    <div class="language-options">
                        <p>Eng</p>
                        <p>Fr</p>
                    </div>
                </div>
                <div class="top-butoons">
                    <h2>Links</h2>
                    <ul>
                        <li><a href="/about-us">About Us</a></li>
                        <li><a href="/application-forms">Membership</a></li>
                        <li>Facilities</li>
                        <li><a href="/program-overview">Programs</a></li>
                        <li><a href="/legal">Legal</a></li>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                        <li><a href="/terms-and-conditions">Terms and Conditions</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bottom-half">
            <p>{{dataList.copyright}}</p>
        </div>
    </div>
</template>

<script setup>
/* eslint-disable */ 
import { ref, onMounted  } from "vue";
import axios from 'axios';

const loggedId = ref(localStorage.getItem('userid'));
const created_by = ref(localStorage.getItem('userid'));
let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/";
const dataList = ref('')
const logoImage = ref('');

onMounted( async () => {
  await listLogo();
})


const listLogo = async () => {
  try {
    const response = await axios.get('/logo_lists.php', { });
   const logoData = response.data.data[0];
    dataList.value = response.data.data[0];
    logoImage.value = `${base_url}${logoData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

</script>


<style scoped lang="scss">
.footer-container {
    margin-top: 5rem;
    background-color: #0C1518;
    border-radius: 20px;
    padding: 2rem;
    height: 450px;
    width: 100%;
}
.play-app-store{
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;

    img{
        width: 100px;
    }
}
.top-half {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 2rem;
    color: #fff;

    .top-logo {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 50%;
        justify-content: start;
        align-items: start;

        p {
            font-size: 0.8rem;
            line-height: 1.5;
            color: #B0B0B0;
            text-align: left;
            max-width: 420px;
            margin: 0%;
            padding: 0%;
        }

        button {
            background: none;
            border: none;
            color: #fff;
            margin: 0%;
            padding: 0%;
            font-size: 13px;
        }

        .down-half-buttons {
                display: flex;
                flex-direction: row;
                gap: 1rem;

                button {
                    background-color: #fff;
                    border: none;
                    color: #8F9FA3;
                    font-size: 13px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: left;
                }
            }
    }

    .top-butoons {
        display: flex;
        flex-direction: column;

        h2 {
            font-size: 16px;
            color: #fff;
            //margin-bottom: 10px;
            padding: 0%;
            text-align: left;
        }

        ul {
            background: none;
            border: none;
            color: #8F9FA3;
            font-size: 13px;
            margin: 0%;
            padding: 0%;
            text-align: left;
            list-style: none;
            a{
                text-decoration: none;
                color: #8F9FA3;
            }
        }
    }

    .second-half {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 20px;

        .contact-location {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .contact {
                h2 {
                    font-size: 16px;
                    color: #fff;
                    //margin-bottom: 10px;
                    padding: 0%;
                    text-align: left;
                }

                ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;

                    li {
                        text-align: left;
                        color: #8F9FA3;
                        font-size: 14px;
                        margin: 5px 0;
                    }
                }
            }

            .location {
                //margin-top: 2rem;

                h2 {
                    //margin-bottom: 10px;
                    font-size: 16px;
                    color: #fff;
                    // margin: 0%;
                    padding: 0%;
                    text-align: left;
                }

                p {
                    font-size: 14px;
                    color: #8F9FA3;
                    margin: 0%;
                    padding: 0%;
                    text-align: left;
                    //max-width: 170px;
                }
            }

          .languages {
            display: flex;
            flex-direction: column;

            p {
                color: #fff;
                font-size: 16px;
            }

            .language-options {
                display: flex;
                gap: 10px;
                //margin-top: 10px;

                p {
                    color: #fff;
                    font-size: 12px;
                }

            }

           }
        }

        
    }
}

.bottom-half {
    //margin-top: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    p {
            color: #fff;
            font-size: 12px;
            text-align: center;
            margin: 0%;
            padding: 0%;
        }

    .bottom-first-half {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .first-half {
            padding-left: 2rem;
            display: flex;
            justify-self: end;
            align-items: end;
            gap: 1rem;

            .second-half-buttons {
                display: flex;
                flex-direction: column;
                gap: 1rem;

                button {
                    background-color: #fff;
                    border: none;
                    color: #8F9FA3;
                    font-size: 16px;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: left;
                }
            }

           
        }

       
    }
}

@media (max-width: 768px) {
    .second-half {
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 20px;

            .contact-location {
                display: flex;
                flex-direction: column !important;

                .contact {
                    h2 {
                        font-size: 16px;
                        color: #fff;
                        margin-bottom: 10px;
                        padding: 0%;
                        text-align: left;
                    }

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;

                        li {
                            text-align: left;
                            color: #8F9FA3;
                            font-size: 14px;
                            margin: 5px 0;
                        }
                    }
                }

                .location {
                    margin-top: 2rem;

                    h2 {
                        margin-bottom: 10px;
                        font-size: 16px;
                        color: #fff;
                        // margin: 0%;
                        padding: 0%;
                        text-align: left;
                    }

                    p {
                        font-size: 14px;
                        color: #8F9FA3;
                        margin: 0%;
                        padding: 0%;
                        text-align: left;
                        max-width: 170px;
                    }
                }
            }

            .languages {
                display: flex;
                flex-direction: column;
                justify-content: start;
                align-items: start;

                p {
                    color: #fff;
                    font-size: 16px;
                    margin: 0%;
                    padding: 0%;
                }

                .language-options {
                    display: flex;
                    gap: 10px;
                    margin-top: 10px;

                    p {
                        color: #fff;
                        font-size: 12px;
                        // margin-top: 10px;
                    }

                    p:nth-child(2) {
                        color: #8F9FA3;
                        font-size: 14px;
                        // margin-top: 10px;
                    }
                }

            }
        }
}

@media (max-width: 768px) {
    .footer-container {
        margin-top: 5rem;
        background-color: #0C1518;
        border-radius: 20px;
        padding: 0px;
        height: auto;
        width: 100%;
    }

    .top-half {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: start;
        padding: 2rem;
        color: #fff;

        .top-logo {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            width: 100%;
            justify-content: start;
            align-items: start;

            p {
                font-size: 1rem;
                line-height: 1.5;
                color: #B0B0B0;
                text-align: left;
                max-width: 420px;
                margin: 0%;
                padding: 0%;
            }

            button {
                background: none;
                border: none;
                color: #fff;
                margin: 0%;
                padding: 0%;
                font-size: 12px;
            }
        }

        .top-butoons {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 10px;

            button {
                background: none;
                border: none;
                color: #8F9FA3;
                font-size: 16px;
                margin: 0%;
                padding: 0%;
                text-align: left;
            }
        }
    }

    .bottom-half {
        display: flex;
        flex-direction: column;
        align-items: start;
        width: 100%;

        .bottom-first-half {
            display: flex;
            justify-content: space-between;
            align-items: end;
            width: 100%;

            .first-half {
                padding-left: 2rem;
                display: flex;
                justify-self: end;
                align-items: end;
                gap: 1rem;

                .second-half-buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;

                    button {
                        background-color: #fff;
                        border: none;
                        color: #8F9FA3;
                        font-size: 16px;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: left;
                    }
                }

                .down-half-buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;

                    button {
                        background-color: #fff;
                        border: none;
                        color: #8F9FA3;
                        font-size: 16px;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: left;
                    }
                }
            }
        }
    }
}
</style>
